module.exports = __webpack_public_path__ + "media/5.e9efcad4.wav";